import { render, staticRenderFns } from "./reservationListForm.vue?vue&type=template&id=0bde59e2&"
import script from "./reservationListForm.vue?vue&type=script&lang=ts&"
export * from "./reservationListForm.vue?vue&type=script&lang=ts&"
import style0 from "./reservationListForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports